import React  from "react";
import {Edit,SimpleForm, Create } from 'react-admin';
import InputGuesser from 'UI/Common/ApiPlateform/InputGuesser';
import {useResourceOptions} from "../../hooks";
import {CurrencyInputField} from "../Common/Currency";

const SimpleFormCommon = ({...props}) => {
    const { writableFields, operations } = useResourceOptions(props.resource);
    if(!operations || !operations.edit) return null;

    return (
        <SimpleForm variant="standard" {...props}>
            {writableFields.name && <InputGuesser source='name' label='name'/>}
            {writableFields.dailyBudget && <CurrencyInputField source='dailyBudget' label='dailyBudget'/>}
        </SimpleForm>
    )
};

export const EditFinal = ({...props}) => {
    return (
        <Edit component={'div'} title="Post view" undoable={false} {...props }>
            <SimpleFormCommon {...props}/>
        </Edit>
    );
};

export const CreateFinal = ({...props}) => {
    return (
        <Create component={'div'}  undoable={false} {...props}>
            <SimpleFormCommon/>
        </Create>
    );
};
